import { render } from "./ConsultingView.vue?vue&type=template&id=7bb0dca2"
import script from "./ConsultingView.vue?vue&type=script&lang=js"
export * from "./ConsultingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__